import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import {
  InvoiceMarketingDashboardDto,
  InvoiceTableDto,
  InvoiceTableQuery,
  InvoiceTrendChartDto,
  InvoiceTrendChartQuery,
} from '../../../models/finance/invoice-list.model';

@Injectable({
  providedIn: 'root',
})
export class ApiInvoiceListService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getInvoiceForTable(query: InvoiceTableQuery): Observable<InvoiceTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      userId: query.userId,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.startDate) params['startDate'] = query.startDate;
    if (query.endDate) params['endDate'] = query.endDate;
    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;
    if (query.sortColumn) params['sortColumn'] = query.sortColumn;
    if (query.sortDirection) params['sortDirection'] = query.sortDirection;
    if (query.status && query.status !== 'all') params['status'] = query.status;
    if (query.minTotal != null) params['minTotal'] = query.minTotal;
    if (query.minRemaining != null) params['minRemaining'] = query.minRemaining;

    return this.apiMethodService.request<InvoiceTableDto>(
      '/backoffice/getInvoiceForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getInvoiceForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getInvoiceMarketingDashboard(
    siteId: number,
    userId: number,
    startDate?: string,
    endDate?: string
  ): Observable<InvoiceMarketingDashboardDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { siteId, userId };
    if (startDate) params['startDate'] = startDate;
    if (endDate) params['endDate'] = endDate;

    return this.apiMethodService.request<InvoiceMarketingDashboardDto>(
      '/backoffice/getInvoiceMarketingDashboard',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getInvoiceMarketingDashboard',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getInvoiceTrendChart(query: InvoiceTrendChartQuery): Observable<InvoiceTrendChartDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      userId: query.userId,
      mode: query.mode,
    };

    if (query.startDate) params['startDate'] = query.startDate;
    if (query.endDate) params['endDate'] = query.endDate;
    if (query.monthStart) params['monthStart'] = query.monthStart;
    if (query.monthEnd) params['monthEnd'] = query.monthEnd;
    if (query.dailySubMode) params['dailySubMode'] = query.dailySubMode;

    return this.apiMethodService.request<InvoiceTrendChartDto>(
      '/backoffice/getInvoiceTrendChart',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getInvoiceTrendChart',
        token,
        headerOnly: false,
        params,
      }
    );
  }
}
